import { toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import type { ISurveyFormValues, ISurveyModel, ISurveySubmitResult } from '@/types/surveys/survey';

const SURVEY_ENDPOINT = '/api/register/survey';

const defaultSurveyModel: ISurveyModel = {
    id: 0,
    editKey: '',
    askReimbursementQuestion: false,
    requireIncomeRange: false,
    incomeRanges: [],

    languageData: {},
};

/** The agreement questions are rated 1-5, over an AgreementLevel that starts at 0. */
const toAgreementLevelOrNull = (value: string) => {
    const stars = toIntOrNull(value);

    return stars != null ? stars - 1 : null;
};

export const useSurvey = (registrationId: number, editKey: string) => {
    const url = `${SURVEY_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel<ISurveyModel>(url, defaultSurveyModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<ISurveyFormValues, DashRegistrationStep, ISurveySubmitResult>(
        url,
        (values) => ({
            surveySurgeonCare: toIntOrNull(values.surveySurgeonCare),
            surveyNurseCare: toIntOrNull(values.surveyNurseCare),
            surveyPainCare: toIntOrNull(values.surveyPainCare),
            surveyCaretakerTreatment: toIntOrNull(values.surveyCaretakerTreatment),
            annualIncomeRange: model.requireIncomeRange ? toIntOrNull(values.annualIncomeRange) : null,
            surveyDonationWasFinancialBurden: toAgreementLevelOrNull(values.surveyDonationWasFinancialBurden),
            surveyDonationCostWasImportant: toAgreementLevelOrNull(values.surveyDonationCostWasImportant),
            surveyNeededReimbursement: model.askReimbursementQuestion ? toIntOrNull(values.surveyNeededReimbursement) : null,
            commendations: values.commendations,
            comments: values.comments,
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
